import { render, staticRenderFns } from "./doctorsChart.vue?vue&type=template&id=24a159c9"
import script from "./doctorsChart.vue?vue&type=script&lang=js"
export * from "./doctorsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports